import type { DepartmentFlatNode, DepartmentFlatTree, DepartmentItem } from '../../Contracts/DepartmentTree.types'

export function buildFlatTree(departments: DepartmentItem[]): DepartmentFlatTree {
    const flatTree: DepartmentFlatTree = {}

    departments.forEach((dept) => {
        const id = dept.id.toString()
        flatTree[id] = {
            ...dept,
            id,
            name: dept.title,
            type: dept.lvl === 0 ? 'input' : undefined,
            children: [],
        }
    })

    departments.forEach((dept) => {
        if (dept.parent && dept.parent.id !== undefined) {
            const parentId = dept.parent.id.toString()
            const currentId = dept.id.toString()
            const parentNode: DepartmentFlatNode | undefined = flatTree[parentId]
            if (parentNode) {
                parentNode.children.push(currentId)
            }
        }
    })

    return flatTree
}
